import { NextPage, NextPageContext } from 'next'
import getLocaleFromCtx from '@/lib/getLocaleFormCtx'
import React, { useContext } from 'react'
import dynamic from 'next/dynamic'
import ProfileContext from '@/components/Context/ProfileContext'
import HomeNotConnected from '@/components/HomeNotConnected/HomeNotConnected'
import MostSearchedBrands from '@/components/Home/MostSearchedBrands'
import BannerGroupement from '@/components/Home/BannerGroupement'
import CarrouselBanner from '@/components/Home/CarrouselBanner'
import HomeAdvantage from '@/components/Home/HomeAvantage'
import AeliaServicesBanner from '@/components/Home/AeliaServicesBanner'
import HomeRecommend from '@/components/Recommend/HomeRecommend'

// Code-split : sort react-swipeable-views du first-load. SSR conserve (LCP banniere).
const HomeCarousel = dynamic(() => import('../components/Home/HomeCarousel'))

const Home: NextPage = () => {
  const { isAuthenticated } = useContext(ProfileContext)

  if (!isAuthenticated) return <HomeNotConnected />

  return (
    <>
      <BannerGroupement />

      <HomeCarousel />

      {/* Marques puis nouveaux partenaires, empilés */}
      <div className="flex flex-col my-4">
        <MostSearchedBrands />
        <CarrouselBanner />
      </div>

      <HomeRecommend />

      <HomeAdvantage />

      <AeliaServicesBanner />
    </>
  )
}

Home.getInitialProps = async (ctx: NextPageContext): Promise<any> => {
  if (!ctx.query.locale && ctx.res) {
    const locale = getLocaleFromCtx(ctx)

    ctx.res.writeHead(302, {
      Location: `/${locale}/home`,
    })
    ctx.res.end()
  }

  return {}
}

export default Home
